import cloneDeep from 'lodash/cloneDeep'
import baseDefaults from '../Base/Base.defaults'
import baseButtonDefaults from '../BaseButton/BaseButton.defaults'

export default  {
  
  ...cloneDeep(baseDefaults),

  confirmButton: Object.assign({}, cloneDeep(baseButtonDefaults), {
    text: "Confirm Upsell",
  }),

  declineButton: Object.assign({}, cloneDeep(baseButtonDefaults), {
    text: 'Decline',
    variant: 'outlined'
  }),

  payInvoiceButton: Object.assign({}, cloneDeep(baseButtonDefaults), {
    text: 'Confirm'
  }),

  product: {
    productId: '',
    pricingOptionId: ''
  },

  confirmAction: {},
  declineAction: {},
}

